import { jsx as _jsx } from "react/jsx-runtime";
import { isValidSpacing } from './utils';
import styled, { css } from 'styled-components';
import { pl, mt, map } from '@nib/layout';
import Copy from './Copy';
const spacingStyles = space => css`
  ${map(space, val => isValidSpacing(val) && css`
        > li:not(:first-child) {
          ${mt(val)};
        }
      `)}
`;
const indentStyles = indent => css`
  ${map(indent, val => isValidSpacing(val) && css`
        ${pl(val)};
      `)}
`;
const insetStyles = (inset, position) => css`
  ${map(inset, val => isValidSpacing(val) && css`
        ${position === 'inside' ? css`
              > li::before {
                content: '';
                ${pl(val)};
              }
            ` : css`
              > li {
                ${pl(val)};
              }
            `}
      `)}
`;
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const BaseListStyles = _ref => {
  let {
    space,
    inset,
    listType,
    position,
    indent
  } = _ref;
  return css`
  margin: 0;
  padding: 0;
  list-style-type: ${listType};
  list-style-position: ${position};
  ${space && spacingStyles(space)};
  ${inset && insetStyles(inset, position)};
  ${indent && indentStyles(indent)};
`;
};
const StyledOrderedList = styled.ol`
  ${_ref2 => {
  let {
    space,
    inset,
    listType,
    position,
    indent
  } = _ref2;
  return css`
    ${BaseListStyles({
    space,
    inset,
    listType,
    position,
    indent
  })};
  `;
}}
`;
const StyledUnorderedList = styled.ul`
  ${_ref3 => {
  let {
    space,
    inset,
    listType,
    position,
    indent
  } = _ref3;
  return css`
    ${BaseListStyles({
    space,
    inset,
    listType,
    position,
    indent
  })};
  `;
}}
`;
export const OrderedList = props => {
  const {
    listType = 'decimal',
    space = 2,
    indent = {
      xs: 4,
      md: 6
    },
    inset = {
      xs: 4,
      md: 6
    },
    position = 'outside',
    start,
    reversed = false,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(StyledOrderedList, {
    "data-mesh-component": "ORDERED-LIST",
    indent: indent,
    listType: listType,
    inset: inset,
    position: position,
    space: space,
    start: start,
    reversed: reversed,
    ...otherProps,
    children: children
  });
};
OrderedList.displayName = 'OrderedList';
export const UnorderedList = props => {
  const {
    listType = 'disc',
    space = 2,
    indent = {
      xs: 4,
      md: 6
    },
    inset = {
      xs: 4,
      md: 6
    },
    position = 'outside',
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(StyledUnorderedList, {
    "data-mesh-component": "UNORDERED-LIST",
    indent: indent,
    listType: listType,
    position: position,
    inset: inset,
    space: space,
    ...otherProps,
    children: children
  });
};
UnorderedList.displayName = 'UnorderedList';
export const ListItem = styled(Copy).attrs({
  component: 'li'
})``;
ListItem.displayName = 'ListItem';